module.exports = "<span>{{ item }}</span>"


//////////////////
// WEBPACK FOOTER
// ./ng2/shared/checklist-item/checklist-item.component.html
// module id = 1217
// module chunks = 0